import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["children"];
import React from 'react';
import ErrorBoundary from './ErrorBoundary';
import { jsx as _jsx } from "react/jsx-runtime";
var Preview = function Preview(_ref) {
  var children = _ref.children,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(ErrorBoundary, _extends({}, rest, {
    children: /*#__PURE__*/_jsx("div", {
      className: "rcv-render",
      children: children ? children : /*#__PURE__*/_jsx("div", {
        className: "rcv-render-loader",
        children: "Rendering..."
      })
    })
  }));
};
export default Preview;